module.exports = __webpack_public_path__ + "img/icon_linghuofuyong.a7e22ebe.png";